var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M62 124C96.2417 124 124 96.2417 124 62C124 27.7583 96.2417 0 62 0C27.7583 0 0 27.7583 0 62C0 96.2417 27.7583 124 62 124Z",
    fill: "#32BA7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.1577 89.9682L78.0378 121.848C104.442 114.807 124 90.7505 124 61.9998C124 61.413 124 60.8263 124 60.2395L98.9653 37.1606L46.1577 89.9682Z",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M63.5647 75.8862C66.3028 78.6243 66.3028 83.3184 63.5647 86.0565L57.8927 91.7285C55.1546 94.4666 50.4606 94.4666 47.7224 91.7285L22.8833 66.6937C20.1451 63.9556 20.1451 59.2616 22.8833 56.5234L28.5552 50.8515C31.2934 48.1133 35.9874 48.1133 38.7255 50.8515L63.5647 75.8862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M85.2745 32.6625C88.0126 29.9243 92.7066 29.9243 95.4448 32.6625L101.117 38.3344C103.855 41.0726 103.855 45.7666 101.117 48.5048L58.0883 91.3376C55.3502 94.0758 50.6562 94.0758 47.918 91.3376L42.2461 85.6657C39.5079 82.9275 39.5079 78.2335 42.2461 75.4953L85.2745 32.6625Z",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/successTick.bbd826023a27b16647b5b1aa1bbeda8e.svg";
export { ForwardRef as ReactComponent };